import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Menage from "@/pages/Menage";
import Conciergerie from "@/pages/Conciergerie";
import APropos from "@/pages/APropos";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import NosServices from "@/pages/NosServices";
import Applications from "@/pages/Applications";
import Legal from "@/pages/Legal";
import NosLocations from "@/pages/NosLocations";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/menage" element={<Menage />} />
            <Route path="/conciergerie" element={<Conciergerie />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/a-propos/faq-generale" element={<Faq />} />
            <Route path="/nos-locations" element={<NosLocations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact/mentions-legales" element={<Legal type="mentions-legales" />} />
            <Route path="/contact/cgv" element={<Legal type="cgv" />} />
            <Route
              path="/contact/politique-de-confidentialite"
              element={<Legal type="politique-de-confidentialite" />}
            />
            <Route path="/nos-services" element={<NosServices />} />
            <Route path="/nos-services/applications" element={<Applications />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
